import React, { useState, useEffect } from 'react';
import SignInButton from '../SignInButton/SignInButton';
import SignOutButton from '../Signout/Signout'; // adjust if folder name is different

function AuthToggleButton() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const adminId = localStorage.getItem('adminId');
     const superadminId = localStorage.getItem('superadminId');
    setIsLoggedIn(!!userId || !!adminId || !!superadminId);
  }, []);

  const handleLoginStatusChange = () => {
    const userId = localStorage.getItem('userId');
    const adminId = localStorage.getItem('adminId');
    const superadminId = localStorage.getItem('superadminId');
    setIsLoggedIn(!!userId || !!adminId || !!superadminId);
  };

  return isLoggedIn ? (
    <SignOutButton onSignOut={handleLoginStatusChange} />
  ) : (
    <SignInButton onSignIn={handleLoginStatusChange} />
  );
}

export default AuthToggleButton;
